
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <b>Maria A., 90, verstorben am 15. April 2020</b>
    <br />
    <br />
    <i>Ihr Sohn erzählt:</i>
    <br />
    <p>
  «Ich möchte mich bei denjenigen bedanken, die den an Covid-19 verstorbenen
  Menschen Tribut zollen wollen. Sie sind es, die in dieser schrecklichen
  Pandemie am meisten gelitten haben. Sie sind die ersten Opfer.
    </p>
    <p>
  Mama hat uns plötzlich verlassen. Sie hatte keine gesundheitlichen Probleme,
  bevor sie in ihrem Pflegeheim positiv getestet wurde. Man hat sie sofort in
  eine andere Einrichtung verlegt, die eine bessere Isolation und Behandlung
  ermöglichte. Trotzdem starb sie.
    </p>
    <p>
  Für diejenigen, die bleiben, ist der Schmerz immens. Wegen der Einschränkungen
  im Zusammenhang mit dem Coronavirus ist auch der Trauerprozess schwierig. Wir
  hatten nur noch telefonischen Kontakt. Dann gab es auch Beschränkungen für die
  Beerdigung.
    </p>
    <p>
  Wir haben Covid-19 auf der Todesanzeige meiner Mutter vermerkt. Es ist für uns
  eine Art, ihr und allen Opfern des Coronavirus die Ehre zu erweisen. Diese
  Erwähnung ist auch für die Geschichte dieser Pandemie da.»
    </p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;